import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { usePlaidLink } from "react-plaid-link";

import ConfirmDialog from "./ConfirmDialog";
import LoadingComponent from "./LoadingComponent";

import api from "../services/api";

export default ({ isSixth, children }) => {
  const [loading, setLoading] = useState(false);

  const onSuccess = useCallback(async (token, metadata) => {
    setLoading(true);
    await api.exchangePlaidToken(token, metadata);
    setLoading(false);
  }, []);

  const onEvent = useCallback(
    (eventName, metadata) => null, //console.log("onEvent", eventName, metadata),
    []
  );

  const onExit = useCallback(
    (err, metadata) => null, // console.log("onExit", err, metadata),
    []
  );

  const userId = useSelector((state) => state.firebase.auth.uid);

  const config = {
    clientName: "Reconcile",
    env: api.isProd() ? "production" : "development",
    product: ["transactions"],
    publicKey: api.getPlaidPublicKey(),
    onSuccess,
    onEvent,
    onExit,
    webhook: api.getPlaidWebhookUrlForUid(userId),
  };
  const { open, ready, error } = usePlaidLink(config);

  const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(false);

  const subscription = useSelector((state) => state.stripe.subscription);
  const subscriptionActive =
    subscription &&
    (subscription.status === "active" || subscription.status === "trialing");

  const onClick = () => {
    if (subscriptionActive && !isSixth) {
      open();
    } else setSubscriptionDialogOpen(true);
  };
  return (
    <>
      {React.cloneElement(children, {
        onClick,
        disabled: !ready || error || !subscription || loading,
      })}
      <ConfirmDialog
        title="Add an acocunt"
        open={subscriptionDialogOpen}
        onCancel={() => setSubscriptionDialogOpen(false)}
        onConfirm={() => setSubscriptionDialogOpen(false)}
      >
        {isSixth
          ? "You can only link 5 instituions."
          : "You need to resolve your billing issue before you can link another institution."}
      </ConfirmDialog>
      {loading && <LoadingComponent />}
    </>
  );
};
